module.exports = __webpack_public_path__ + "img/tag_middle_icon.ef7b74cd.png";